import { useEffect } from 'react';

export const useScrollLock = (target: HTMLElement | null, enabled: boolean) => {
  useEffect(() => {
    if (!enabled || !target) return;

    const originalOverflow = target.style.overflow;
    target.style.overflow = 'hidden';

    return () => {
      target.style.overflow = originalOverflow;
    };
  }, [target, enabled]);
};
